<div class="add-fitting-btn-container">
  <div class="add-fi-1">
    <button class="btn add-fi-2 m-1" (click)="setAddFittingMode()">Add Fittings</button>
  </div>
</div>
